<script setup>
import { ref, onMounted } from 'vue';
import { useServiceStore } from '@/stores/serviceStore';
import { useRequestsStore } from '@/stores/storeRequests';
import { useRouter } from 'vue-router';

import img_0 from '@/assets/img/equipments/equipment_0.jpg';
import img_1 from '@/assets/img/equipments/equipment_1.jpg';
import img_2 from '@/assets/img/equipments/equipment_2.jpg';

const equipmentImages = [img_0, img_1, img_2];

const storeService = useServiceStore();
const storeRequests = useRequestsStore();
const router = useRouter()

const nextSreen = async () => {   // rentalType = "court", rentalAt, price, crmId, title = ''
    
    storeService.goToScreen(storeService.screens.bookings)
    router.push({ hash: `#${storeService.screens.bookings}`})
}

const previousSreen = () => {
    storeService.goToScreen(storeService.screens.services)
    router.push({ hash: `#${storeService.screens.services}`})
    sessionStorage.removeItem('courtIdToken')
    storeService.clearSessionCourtTimes()
    storeService.clearSessionSelectedCourt()
}


onMounted(() => {
    storeService.hideScreenLoader()
})
</script>

<template>
    <div class="services-container">
        <div class="container">
            <button class="services-btn-back" @click="previousSreen">
                <svg width='24' height='24'><use href='#back_icon'></use></svg>
                <span>Назад</span>
            </button>
            <h2 class="service-title">Выберите инвентарь</h2>

        </div>
            <div class="service">
                <div class="service__slider slider">
                    <swiper-container
                        class="service__swiper"
                        centered-slides="true"
                        speed="800"
                        initialSlide= "0"
                        :navigation="{
                            nextEl: '.slider__next',
                            prevEl: '.slider__prev',
                        }" 
                        :breakpoints="{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 5
                            },
                            769: {
                                slidesPerView: 2,
                                spaceBetween: 100
                            },
                         
                            1441: {
                                slidesPerView: 2,
                                spaceBetween: 230
                            }
                        }"
                    >
                        <swiper-slide  class="service__slide" v-for="(equipment, index) of storeRequests.listQuipments" :key="equipment.id">
                            <div class="service__slide-item">
                                <div class="service__slide-image">
                                    <img class='full-img' width='670' height='426' :src='equipmentImages[index]' alt='изображение'>
                                </div>
                                <div class="service__slide-footer">
                                    <div class="service__slide-name">{{ equipment.title }}</div>
                                    <div class="service__slide-price">
                                        <span>Стоимость:</span>
                                        <span>{{ equipment.price }} ₽</span>
                                    </div>
                                    <button 
                                        class="service__slide-btn btn --full" 
                                        @click="nextSreen(), storeService.addCourtTime('equipment', null, equipment.price, equipment.id, equipment.title, equipment.description)"
                                    >
                                        Выбрать
                                    </button>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper-container>
                    <div class="slider__controls">
                        <button class="slider__prev slider__btn">
                            <svg width='40' height='40'><use href='#slider__prev'></use></svg>
                        </button>
                        <button class="slider__next slider__btn">
                            <svg width='40' height='40'><use href='#slider__next'></use></svg>
                        </button>
                    </div>
                </div>
            </div>
            
    </div>
</template>
<style lang='scss' scoped>
swiper-container::part(container) {
    padding-bottom: 15rem;
}



</style>